<template>
<div id="app">
  <section class="hero is-black is-fullheight">
    <div class="hero-body bg-img" :style="background">
      <div class="container has-text-centered">
        <a @click="reset">
          <figure style="margin-bottom: 60px;">
            <img src="./assets/cnosfap5.png" alt="Logo cnos-fap" width="220">
          </figure>
        </a>

        <router-view />

        <div style="display: flex; justify-content: center;">
          <div class="tags has-addons">
            <span class="tag is-primary">Versione</span>
            <span class="tag is-dark">{{info.version}}</span>
          </div>
        </div>
      </div>

      <!-- Container -->
      <div style="position: fixed; right: 10px; bottom: 10px;">
        <span class="tag is-dark is-size-7" @click="randomize()">cambia sfondo</span>
      </div>
    </div>
  </section>
</div>
</template>
<script>
import Package from '../package.json'
import Auth from '@/service/auth'

export default {
  name: 'home',
  data() {
    return {
      info: Package,
      background: '',
      backgrounds: [
        'amsterdam',
        'city-landscape',
        'forest-water',
        'forest',
        'forest2',
        'forest3',
        'forest4',
        'nature-raining',
        'nature-sea',
        'river',
        'river2',
        'sea',
        'snow',
        'miracle',
        'cave-light',
        'cityfog',
        'mountain',
        'cloudwaves',
      ],
    }
  },

  created() {
    this.randomize()
  },

  methods: {
    randomize() {
      const backgrounds = this.backgrounds
      const select = backgrounds[Math.floor(Math.random() * backgrounds.length)]
      const style = 'background-image:url(../static/bg/' + select + '.gif)'
      this.background = style
    },

    reset() {
      Auth.logout()
      window.location.href = '/'
    },
  },
}
</script>

<style >
#app {
  font-family: 'Titillium Web', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bg-img {
  /* background-image: url(../static/bg/snow.gif); */
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-color: #999;
}
.container {
  max-width: 400px;
}
.bordered {
  background: repeating-linear-gradient(
    0deg,
    #ffffff,
    #ffffff 6px,
    #6041bf 6px,
    #6041bf 8px
  );
}

.shadow {
  /*  margin-top: 10px; */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);
  padding: 0px;
  margin: 0px;
}
.button {
  border-radius: 5px;
}
.box {
  margin-top: 1rem;
  margin-bottom: 0px;
}
.avatar {
  margin-top: -60px;
  padding-bottom: 5px;
}
.avatar img {
  padding: 4px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.trasparent {
  position: relative;
  z-index: 100;
  padding: 20px;
  background: rgb(255, 255, 255); /* for IE */
  background: rgba(255, 255, 255, 0.65);
}
.tag.is-dark {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue